/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import AttributeGroup from './AttributeGroup'
import i18n from '@/i18n'
import PaymentColors from '@/model/dataLayer/api/common/PaymentColors'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'
import Dish, { booleanOptions } from '@/model/dataLayer/api/dish/Dish'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import { defaultLanguage } from '@/model/global/DefaultLanguage'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      required: false,
      type: {
        root: () => getRootUrl() + GlobalSettings.dcImageRoot
      }
    }
  },
  _langsname: {
    displayName: 'name',
    form: false
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'attribute',
      default: defaultLanguage(),
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name', 'desc'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false
  },
  priceMod: {
    type: IKDataEntity.Types.Float,
    displayName: 'price',
    formConfig: {
      overwriteRule: true,
      rule: [
        v => /^(-)?[0-9]+\.{0,1}[0-9]{0,2}$/.test(v) || this.$t('pls_enter_the_correct_price')
      ]
    }
  },
  attributeGroupId: {
    displayName: 'groupName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: AttributeGroup.forceGetList
      }
    },
    header: false
  },
  value: {
    displayName: 'sort',
    formConfig: {
      default: 1
    },
    header: false
  },

  dishesCategoryTypeId: {
    displayName: 'TaxRate',
    type: IKDataEntity.Types.Option,
    formConfig: {
      default: 9,
      type: {
        selectItems: async () => {
          const res = (await CategoryType.getList(true))
          res.forEach(it => {
            it.name = it._langsname
          })
          return res
        },
        color: PaymentColors.getList()
      }
    }
  },
  frontendHide: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  },
  useTeaMaker: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return booleanOptions
        },
        itemText: 'label',
        itemValue: 'value'
      },
      default: 0,
      required: false
    },
    header: false
  },
  teaMakerCode: {
    type: IKDataEntity.Types.String,
    formConfig: {
      required: false
    },
    header: false
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  }

}
const config = {
  add: async function (item) {
    item.langs = JSON.stringify(item.langs)
    return (await hillo.postWithUploadFile('Category.php?op=addAttribute', item)).content
  },
  edit: function (item) {
    item.langs = JSON.stringify(item.langs)
    return hillo.postWithUploadFile('Category.php?op=updateAttribute', item)
  },
  remove: function (id) {
    return hillo.post('Category.php?op=deleteAttribute', { id })
  },
  load: async function (filter) {
    const res = (await hillo.get('Category.php', {
      op: 'showAttribute',
      lang: GlobalSettings.getLang()
    }))
      .content.map(it => {
        it.langs = it.langs.map(i => {
          return {
            ...i,
            desc: i.description
          }
        })
        return it
      })
    return res
  },
  name: function () {
    return i18n.t('attribute')
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function toggleAttributeGroup (agId, dishesId) {
  const item = (await Dish.getList()).find(it => it.dishId === dishesId)
  if (item.attributeGroupId.includes(agId)) {
    item.attributeGroupId = item.attributeGroupId.filter(it => it !== agId)
  } else {
    item.attributeGroupId.push(agId)
  }
  await Dish.edit(item)
}

export async function flipAttributes (id, agId, aId) {
  return (await hillo.post('Dishes.php?op=flipAttributes', {
    idAgIdAIds: JSON.stringify([
      {
        id,
        agId,
        aId
      }
    ])
  })).content
}
